import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import { GetApi } from "../../../js_assets/Network";

import { Grid } from "@material-ui/core";

import { getParameterByName } from "../../../js_assets/getParameterByName";

import AppAdminContainer from "../AppAdminContainer";

import AgGridTable from "../../agGridTable";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 8,
    margin: 12,
  },
  divider: {
    width: "100%",
  },
  btn_login: {
    color: "white",
    padding: "10px 1px",
    border: "none",
    cursor: "pointer",
    width: "30%",
    opacity: "0.9",
    borderRadius: "3px",
    backgroundColor: "#b1d236",
    fontSize: 18,
  },
  ButtonLocation: {
    backgroundColor: "#4CAF50",
    color: "white",
    "&:hover": {
      background: "#4CAF50",
    },
  },
  ButtonGuide: {
    backgroundColor: "#74cbc4",
    color: "white",
    "&:hover": {
      background: "#74cbc4",
    },
    margin: theme.spacing.unit,
    padding: "2px",
  },
  tab: {
    flexGrow: 1,
    marginTop: 2,
    backgroundColor: "#f7faea",
  },
  iocns: {
    fontSize: 18,
  },
});

class InvoiceTrainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Discount_Code: [],
      trainer_point: [],
      trainer_schedule: [],
      loading_Schedule_Table: true,
      loading_state_Point: true,
      loading_state_iocn: true,

      columnDefs: [],
      rowData: [],
      columnDefs_point: [],
      rowData_point: [],
      Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
    };
  }

  componentDidMount() {
    const { Admin_Info } = this.state;

    let TrainerID = getParameterByName("TrainerID");

    if (TrainerID !== null) {
      if (TrainerID === "all") {
        //console.log("TrainerID" + TrainerID)

        Promise.all([
          GetApi(
            `/api/Admin/Get_Discount_Codes/${Admin_Info.admin_Id}`,
            Admin_Info.jwT_Token_Admin
          ),
          GetApi(
            `/api/trainer/Trainer_Subscription_Schedule_Report_All/${TrainerID}`,
            Admin_Info.jwT_Token_Admin
          ),
          GetApi(
            `/api/trainer/Trainer_Point_Summary_Report_All/${TrainerID}`,
            Admin_Info.jwT_Token_Admin
          ),
        ]).then((rep) => {


          this.ini_Subscription_Schedule(rep[1], rep[0]);

          this.ini_Point_Summary(rep[2])


        });
      } else {
        //console.log("TrainerID" + TrainerID)

        Promise.all([
          GetApi(
            `/api/Admin/Get_Discount_Codes/${Admin_Info.admin_Id}`,
            Admin_Info.jwT_Token_Admin
          ),
          GetApi(
            `/api/trainer/Trainer_Subscription_Schedule_Report/${TrainerID}`,
            Admin_Info.jwT_Token_Admin
          ),
        ]).then((rep) => {


          this.ini_Subscription_Schedule(rep[1], rep[0]);

          //this.ini_filter_date_point(rep[2])


        });
      }
    }
  }



  ini_Subscription_Schedule = (Schedule_Report, Discount) => {
    let new_data_arr = [];

    if (Schedule_Report.length != 0) {
      Schedule_Report.map((rep) => {
        rep.subscription_Date = rep.subscription_Date.split("T")[0];

        if (rep.discount_Code_Id != 0 && Discount.length != 0) {
          let result_code = Discount.filter(e => e.discount_Code_Id == rep.discount_Code_Id)

          if (result_code.length != 0) {
            rep.discount_Code_Id = result_code[0].coupon_Code
          } else {
            rep.discount_Code_Id = " كود خصم محذوف"
          }

        } else {
          rep.discount_Code_Id = "بدون كود خصم"
        }

        new_data_arr.push(rep);
      });
    }

    this.setState({
      trainer_schedule: new_data_arr,
      loading_Schedule_Table: false,
    });

    this.init_columnDefs();
  };


  ini_Point_Summary = (point_Report) => {
    let new_data_arr = [];

    if (point_Report.length !== 0) {
      point_Report.map((rep) => {
        rep.date_Point = rep.date_Point.split("T")[0];

        if (rep.consulting_Offer_Used == true) {
          rep.consulting_Offer_Used = "مجانية";
          rep.trainer_Points = 0;
        } else {
          rep.consulting_Offer_Used = "مدفوعه";
        }

        new_data_arr.push(rep);
      });
    }

    this.setState({ trainer_point: new_data_arr, loading_state_Point: false });

    this.init_columnDefs_point();
  };

  get_Point_Summary_Report_by_date = (e) => {
    e.preventDefault();
    const { trainer_point } = this.state;

    this.setState({ loading_state_iocn2: true });

    var startDate = this.refs.startDate_point.value;

    var endDate = this.refs.endDate_point.value;

    //console.log("this.refs.startDate_point.value", this.refs.startDate_point.value)

    var tempArray = trainer_point.filter(function (d, i) {
      return (
        new Date(d.date_Point) >= new Date(startDate) &&
        new Date(d.date_Point) <= new Date(endDate)
      );
    });

    //console.log("tempArray", tempArray)

    this.setState({ rowData_point: tempArray, loading_state_Point: false });
  };

  get_Schedule_Report_by_date = (e) => {
    e.preventDefault();
    const { trainer_schedule } = this.state;

    this.setState({ loading_Schedule_Table: true });

    var startDate = this.refs.startDate.value;

    var endDate = this.refs.endDate.value;

    //console.log("this.refs.startDate.value", this.refs.startDate.value)

    var tempArray = trainer_schedule.filter(function (d, i) {
      return (
        new Date(d.subscription_Date) >= new Date(startDate) &&
        new Date(d.subscription_Date) <= new Date(endDate)
      );
    });



    this.setState({ rowData: tempArray, loading_Schedule_Table: false });
  };


  init_columnDefs = () => {
    const { trainer_schedule } = this.state;

    let columnDefs = [
      { headerName: "اسم المدرب", field: "trainer_Name" },
      { headerName: "نوع الجدول", field: "schedule_Package_Type_Name" },
      { headerName: "قيمة الاشراك", field: "subscription_Price" },
      { headerName: "السعر قبل الخصم", field: "original_Subscription_Price" },
      { headerName: "تاريخ الاشراك", field: "subscription_Date" },
      { headerName: "اسم المستخدم", field: "userName" },
      { headerName: "رقم الجوال", field: "user_Phone" },
      { headerName: "الايميل", field: "user_Email" },
      { headerName: " كود الخصم", field: "discount_Code_Id" },
      { headerName: "رقم ميسر", field: "payment_Transaction_Id" },
    ];

    this.setState({
      columnDefs: columnDefs,
      rowData: trainer_schedule,
      loading_Schedule_Table: false,
    });
  };

  init_columnDefs_point = () => {
    const { trainer_point } = this.state;

    let columnDefs = [
      { headerName: "رقم الاستشاره", field: "conversion_ID" },
      { headerName: "اسم المدرب", field: "trainer_Name" },
      { headerName: "نوع الاستشاره", field: "consulting_Offer_Used" },
      { headerName: "قيمة الاستشاره", field: "trainer_Points" },
      { headerName: "تاريخ الاستشاره", field: "date_Point" },
      { headerName: "اسم المستخدم", field: "userName" },
      { headerName: "رقم الجوال", field: "user_Phone" },
      { headerName: "الايميل", field: "user_Email" },
      { headerName: "رقم ميسر", field: "payment_Transaction_Id" },
    ];

    this.setState({
      columnDefs_point: columnDefs,
      rowData_point: trainer_point,
      loading_state_Point: false,
    });
  };

  render() {
    const { classes } = this.props;
    const {

      columnDefs,
      columnDefs_point,
      rowData_point,
      rowData,
      loading_Schedule_Table
      , loading_state_Point
    } = this.state;

    //console.log()
    return (
      <AppAdminContainer Title={"فاتورة"}>
        <div className="container">
          <div className="center" >
            <h3 className="containerOfferh4"> الاشتراكات </h3>

          </div>



          <span>من  </span>
          <input
            placeholder="تاريخ   مثال  MM-dd-yyyy"
            name="startDate"
            ref="startDate"
            type={"Date"}
          />
          <span>الى  </span>

          <input
            placeholder="تاريخ   مثال  MM-dd-yyyy"
            name="endDate"
            ref="endDate"
            type={"Date"}
          />


          <div >
            <button
              ref={"SearchBtn"}

              onClick={(e) => this.get_Schedule_Report_by_date(e)}
            >
              بحث
            </button>
          </div>




          <div className="center" >
            <AgGridTable
              loading_state_Table={loading_Schedule_Table}
              columnDefs={columnDefs}
              rowData={rowData}

            />
          </div>


          <hr></hr>

          <div className="center" >
            <h3 className="containerOfferh4"> الاستشارات </h3>

          </div>



          <span>من : </span>

          <input

            placeholder="تاريخ   مثال  MM-dd-yyyy"
            name="startDate"
            ref="startDate_point"
            type={"Date"}
          />




          <span>الى : </span>

          <input

            placeholder="تاريخ   مثال  MM-dd-yyyy"
            name="endDate"
            ref="endDate_point"
            type={"Date"}
          />



          <button
            ref={"SearchBtn"}

            onClick={(e) => this.get_Point_Summary_Report_by_date(e)}
          >
            بحث
          </button>





          <br></br>
          <div className="center" >
            <AgGridTable
              loading_state_Table={loading_state_Point}
              columnDefs={columnDefs_point}
              rowData={rowData_point}
            />
          </div>


        </div>
      </AppAdminContainer>
    );
  }
}
InvoiceTrainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(InvoiceTrainer);
